module.exports = __webpack_public_path__ + "img/tv.6daf3e43.svg";